// extracted by css-extract-rspack-plugin
export default {"container":"SubscriptionSection-module__container__HJ1GP","button":"SubscriptionSection-module__button__NziWE","header":"SubscriptionSection-module__header__CATe6"};